<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const customRef = db.ref('custom')

export default {
  name: 'crm-table-motor',
  data() {
    return {
      cls: {},
      loading: true,
      tableItems: [
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center',
        },
        name: {
          label: 'Name',
        },
        nric: {
          label: 'NRIC',
          sortable: true,
        },
        upperCase: {
          label: 'Car Plate',
          sortable: true,
        },
        timestamp: {
          label: 'Timestamp',
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '20em',
          },
        },
      },
    }
  },
  mounted: function() {
    var customs
    customRef.child('motorInsurance').on('value', (snapshot) => {
      customs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          customs.unshift({
            avatar: { url: val.profilePic, tooltip: key },
            name: val.fullName,
            nric: val.nric,
            upperCase: val.carplate,
            timestamp: parseInt(val.timestamp),
            statusString: { carUrl: val.imageUrl, mapUrl: 'null', formUrl: 'null', imageUrl: 'null' },
          })
        })
      console.log(customs)
      this.tableItems = customs
      this.loading = false
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/crmTableMotor.vue?42444a69